import classNames from 'classnames';
import { parseISO } from 'date-fns';
import addMonths from 'date-fns/addMonths';
import startOfMonth from 'date-fns/startOfMonth';
import subMonths from 'date-fns/subMonths';
import { Account } from 'model/IChat';
import React, { useState } from 'react';
import { TODAY_STRING } from '~/timeConstants';

import DatePickerHeader from './DatePickerHeader';
import DatePickerMonth from './DatePickerMonth';

const CSS = require('./DatePicker.module.scss');

interface DatePickerProps {
  selectedDate?: string;
  onDateChange: (newDate: string) => void;
  availableDates?: { date: string; locals?: string[] }[];
  withAvailability?: boolean;
  preferredLocal?: Partial<Account>;
  variant?: 'pink' | 'jade';
  showTwoMonths?: boolean;
  isLoading?: boolean;
}

function DatePicker({
  selectedDate,
  onDateChange,
  availableDates,
  withAvailability,
  preferredLocal,
  variant = 'pink',
  showTwoMonths,
  isLoading,
}: DatePickerProps) {
  const [displayedMonth, setDisplayedMonth] = useState(
    startOfMonth(parseISO(selectedDate || TODAY_STRING)),
  );

  const monthInterval = showTwoMonths ? 2 : 1;

  const onPreviousMonth = () =>
    setDisplayedMonth(subMonths(displayedMonth, monthInterval));
  const onNextMonth = () =>
    setDisplayedMonth(addMonths(displayedMonth, monthInterval));

  const parsedSelectedDay = selectedDate ? parseISO(selectedDate) : undefined;

  const nextMonth = addMonths(displayedMonth, 1);

  return (
    <section
      data-test-id="DatePicker"
      className={classNames({ [CSS.TwoMonthDatePicker]: showTwoMonths })}
    >
      <div>
        <DatePickerHeader
          displayedMonth={displayedMonth}
          onPrevious={onPreviousMonth}
          onNext={!showTwoMonths && onNextMonth}
          showTwoMonths={showTwoMonths}
        />
        <DatePickerMonth
          displayedMonth={displayedMonth}
          selectedDay={parsedSelectedDay}
          onDateChange={onDateChange}
          availableDates={availableDates}
          withAvailability={withAvailability}
          preferredLocal={preferredLocal}
          variant={variant}
          isLoading={isLoading}
        />
      </div>
      {showTwoMonths && (
        <div>
          <DatePickerHeader
            displayedMonth={nextMonth}
            onNext={onNextMonth}
            showTwoMonths={showTwoMonths}
          />
          <DatePickerMonth
            displayedMonth={nextMonth}
            selectedDay={parsedSelectedDay}
            onDateChange={onDateChange}
            availableDates={availableDates}
            withAvailability={withAvailability}
            preferredLocal={preferredLocal}
            variant={variant}
            isLoading={isLoading}
          />
        </div>
      )}
    </section>
  );
}

export default DatePicker;
